  (function () {
    'use strict';

    var API_BASE = 'https://api.judge.me/api/v1/widgets/all_reviews_page';
    var REVIEW_API = 'https://api.judge.me/api/v1/reviews';
    var PRESIGNED_PICTURES_API = 'https://api.judge.me/api/v1/pictures/presigned_data';
    var PER_PAGE = 25;
    var MAX_PAGES = 80;

    function qs(root, sel) {
      return root.querySelector(sel);
    }

    function qsa(root, sel) {
      return Array.prototype.slice.call(root.querySelectorAll(sel));
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function parseDateMs(value) {
      if (!value) return 0;
      var t = Date.parse(value);
      return isNaN(t) ? 0 : t;
    }

    function formatDate(isoOrText) {
      if (!isoOrText) return '';
      var d = new Date(isoOrText);
      if (isNaN(d.getTime())) return String(isoOrText);
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var dd = String(d.getDate()).padStart(2, '0');
      var yyyy = d.getFullYear();
      return mm + '/' + dd + '/' + yyyy;
    }

    function isVerifiedReview(el) {
      if (!el) return false;

      var verifiedBuyer = el.getAttribute('data-verified-buyer');
      if (verifiedBuyer === 'true' || verifiedBuyer === '1' || verifiedBuyer === 'yes') return true;
      if (verifiedBuyer === 'false' || verifiedBuyer === '0' || verifiedBuyer === 'no') return false;

      if (
        qs(
          el,
          '.jm-verified-buyer-badge, .jm-verified-buyer-badge__text, .jdgm-verified-buyer-badge, .jdgm-rev__buyer-badge--verified, .jdgm-verified-badge'
        )
      ) {
        return true;
      }

      var buyerBadge = qs(el, '.jdgm-rev__buyer-badge');
      if (buyerBadge && buyerBadge.textContent.trim()) return true;

      var transparency = qs(el, '.jdgm-rev__transparency-badge');
      if (transparency) {
        var badgeType = transparency.getAttribute('data-badge-type') || '';
        if (
          /store_invitation|review_request|shop_app|verified|confirmed|buyer|email|klaviyo|sms|import/i.test(
            badgeType
          )
        ) {
          return true;
        }
      }

      return !!qsa(el, '.jdgm-rev__buyer-badge-wrapper [class*="verified"], [class*="verified-buyer"]').length;
    }

    function avatarHtml(verified) {
      return (
        '<span class="dcoded-reviews__avatar" aria-hidden="true">' +
        '<svg class="dcoded-reviews__avatar-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<rect width="32" height="32" fill="#ececec"/>' +
        '<circle cx="16" cy="13" r="5" stroke="#999" stroke-width="1.2" fill="none"/>' +
        '<path d="M7 28c0-5 4-8.5 9-8.5s9 3.5 9 8.5" stroke="#999" stroke-width="1.2" fill="none"/>' +
        '</svg>' +
        '<span class="dcoded-reviews__avatar-check' +
        (verified ? ' is-visible' : '') +
        '" aria-hidden="true">' +
        '<svg viewBox="0 0 8 8" width="8" height="8"><path d="M1.5 4L3 5.5 6.5 2" stroke="#fff" stroke-width="1.2" fill="none"/></svg>' +
        '</span>' +
        '</span>'
      );
    }

    var PIN_ICON_HTML =
      '<span class="dcoded-reviews__pin" aria-label="Pinned review">' +
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">' +
      '<path d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"/>' +
      '</svg>' +
      '</span>';

    function initials(name) {
      var parts = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      if (!parts.length) return '?';
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }

    function starSvgHtml(filled) {
      return (
        '<svg class="dcoded-star-svg' +
        (filled ? ' dcoded-star-svg--on' : '') +
        '" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
        '<path d="M12 1.5l2.82 5.71 6.3.92-4.56 4.44 1.08 6.28L12 16.9l-5.64 2.95 1.08-6.28L2.88 8.13l6.3-.92L12 1.5z" fill="currentColor"/>' +
        '</svg>'
      );
    }

    function starsHtml(rating) {
      var n = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
      var html = '';
      for (var i = 1; i <= 5; i++) {
        html += starSvgHtml(i <= n);
      }
      return html;
    }

    function imgSrc(el) {
      if (!el) return '';
      return (
        el.getAttribute('data-src') ||
        el.getAttribute('data-lazy-src') ||
        el.getAttribute('data-original') ||
        el.getAttribute('data-bg') ||
        el.getAttribute('src') ||
        ''
      );
    }

    function normalizeImageUrl(url) {
      if (!url) return '';
      return String(url).trim();
    }

    function pushReviewImage(images, seen, src, href) {
      src = normalizeImageUrl(src);
      if (!src || src.indexOf('data:') === 0) return;
      var key = src.split('?')[0];
      if (seen[key]) return;
      seen[key] = true;
      images.push({ src: src, href: normalizeImageUrl(href) || src });
    }

    function mergeReviewImages(a, b) {
      var seen = {};
      var merged = [];
      (a || []).concat(b || []).forEach(function (img) {
        pushReviewImage(merged, seen, img && img.src, img && (img.href || img.src));
      });
      return merged;
    }

    function mergeReviewLists(seedList, apiList) {
      var map = {};
      (seedList || []).forEach(function (review) {
        map[review.id] = review;
      });
      (apiList || []).forEach(function (review) {
        var prev = map[review.id];
        if (!prev) {
          map[review.id] = review;
          return;
        }
        var images = mergeReviewImages(prev.images, review.images);
        map[review.id] = Object.assign({}, prev, review, {
          images: images,
          hasPictures: images.length > 0,
          verified: prev.verified || review.verified
        });
      });
      return Object.keys(map).map(function (id) {
        return map[id];
      });
    }

    /** Parse a Judge.me .jdgm-rev card into our model (published reviews only from API/seed). */
    function parseCard(el) {
      if (!el || !el.getAttribute) return null;
      var id = el.getAttribute('data-review-id') || el.getAttribute('data-id') || '';
      if (!id) return null;

      var rating =
        parseInt(el.getAttribute('data-score') || el.getAttribute('data-rating') || '0', 10) ||
        qsa(el, '.jdgm-star.jdgm--on, .jdgm-rev__rating .jdgm-star.jdgm--on').length ||
        0;

      var authorEl =
        qs(el, '.jdgm-rev__author') ||
        qs(el, '.jdgm-rev__buyer-name') ||
        qs(el, '[data-reviewer-name]');
      var author = authorEl ? authorEl.textContent.trim() : 'Customer';

      var titleEl = qs(el, '.jdgm-rev__title');
      var title = titleEl ? titleEl.textContent.trim() : '';

      var bodyEl = qs(el, '.jdgm-rev__body') || qs(el, '.jdgm-rev__content');
      var body = bodyEl ? bodyEl.textContent.trim() : '';

      var dateEl =
        qs(el, '.jdgm-rev__timestamp') ||
        qs(el, 'time') ||
        qs(el, '[datetime]');
      var dateRaw =
        (dateEl && (dateEl.getAttribute('datetime') || dateEl.getAttribute('data-content'))) ||
        (dateEl && dateEl.textContent.trim()) ||
        el.getAttribute('data-created-at') ||
        '';

      var productLink = qs(el, '.jdgm-rev__prod-link, .jdgm-rev__product a, a.jdgm-rev__prod-link');
      var productHref = productLink ? productLink.getAttribute('href') || '' : '';
      var productTitle = productLink
        ? productLink.textContent.trim()
        : (qs(el, '.jdgm-rev__prod-title') && qs(el, '.jdgm-rev__prod-title').textContent.trim()) ||
          '';

      var images = [];
      var seen = {};
      qsa(el, '.jdgm-rev__pic-link, a.jdgm-rev__pic-img, .jdgm-rev__pics a').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        var img = qs(a, 'img');
        pushReviewImage(images, seen, imgSrc(img) || href, href || imgSrc(img));
      });
      qsa(
        el,
        '.jdgm-rev__pic-img, .jdgm-rev__pics img, img[data-src*="review"], img[data-src*="judgeme"], img[data-src*="imgix"]'
      ).forEach(function (img) {
        pushReviewImage(images, seen, imgSrc(img), imgSrc(img));
      });
      qsa(
        el,
        'a[href*="review-images"], a[href*="judgeme.imgix"], a[href*="judgeme-public-images"], a[href*="judgeme.com"]'
      ).forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (/\.(jpe?g|png|webp)(\?|$)/i.test(href) || href.indexOf('review-images') !== -1) {
          pushReviewImage(images, seen, href, href);
        }
      });
      qsa(el, '.jdgm-rev__pics [style*="background"], .jdgm-rev__pic[style*="background"]').forEach(
        function (node) {
          var style = node.getAttribute('style') || '';
          var match = style.match(/url\(['"]?([^'")]+)/i);
          if (match && match[1]) pushReviewImage(images, seen, match[1], match[1]);
        }
      );
      qsa(el, '[data-src*="review"], [data-src*="judgeme"], [data-bg*="judgeme"]').forEach(function (node) {
        var src = node.getAttribute('data-src') || node.getAttribute('data-bg') || '';
        pushReviewImage(images, seen, src, src);
      });

      var helpful =
        parseInt(el.getAttribute('data-thumb-up') || el.getAttribute('data-votes-up') || '0', 10) || 0;

      var verified = isVerifiedReview(el);

      var pinned =
        el.classList.contains('jdgm-rev--pinned') ||
        !!qs(el, '.jdgm-rev__pinned') ||
        el.getAttribute('data-pinned') === 'true';

      return {
        id: String(id),
        rating: rating,
        author: author,
        title: title,
        body: body,
        dateRaw: dateRaw,
        dateMs: parseDateMs(dateRaw),
        productHref: productHref,
        productTitle: productTitle,
        images: images,
        hasPictures: images.length > 0,
        helpful: helpful,
        verified: verified,
        pinned: pinned
      };
    }

    function parseFrequenciesFromHeaderHtml(html) {
      if (!html) return null;
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var frequencies = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      var found = false;
      qsa(wrap, '.jdgm-histogram__row[data-rating]').forEach(
        function (row) {
          var r =
            parseInt(row.getAttribute('data-rating') || row.getAttribute('data-score') || '0', 10) ||
            0;
          var f =
            parseInt(
              row.getAttribute('data-frequency') ||
                row.getAttribute('data-count') ||
                '0',
              10
            ) || 0;
          if (!f) {
            var freqEl = qs(row, '.jdgm-histogram__frequency, .jdgm-histogram__count');
            if (freqEl) f = parseInt(freqEl.textContent || '0', 10) || 0;
          }
          if (r >= 1 && r <= 5) {
            frequencies[r] = f;
            found = true;
          }
        }
      );
      return found ? frequencies : null;
    }

    function parseReviewsFromHtml(html) {
      if (!html) return [];
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      return qsa(wrap, '.jdgm-rev[data-review-id], .jdgm-rev[data-id]')
        .map(parseCard)
        .filter(Boolean);
    }

    function parseSeed(section) {
      var seed = qs(section, '[data-dcoded-seed]');
      if (!seed) return { reviews: [], frequencies: null };
      var reviews = qsa(seed, '.jdgm-rev[data-review-id], .jdgm-rev[data-id]')
        .map(parseCard)
        .filter(Boolean);

      var frequencies = parseFrequenciesFromHeaderHtml(seed.innerHTML);

      return { reviews: reviews, frequencies: frequencies };
    }

    function frequenciesFromReviews(reviews) {
      var f = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      reviews.forEach(function (r) {
        var n = Math.round(Number(r.rating) || 0);
        if (n >= 1 && n <= 5) f[n] += 1;
      });
      return f;
    }

    function sortReviews(list, mode) {
      var arr = list.slice();
      if (mode === 'only-pictures') {
        arr = arr.filter(function (r) {
          return r.hasPictures;
        });
      }

      function cmpDate(a, b) {
        return (b.dateMs || 0) - (a.dateMs || 0);
      }

      if (mode === 'pictures-first') {
        arr.sort(function (a, b) {
          if (a.hasPictures !== b.hasPictures) return a.hasPictures ? -1 : 1;
          return cmpDate(a, b);
        });
      } else if (mode === 'highest-rating') {
        arr.sort(function (a, b) {
          if (b.rating !== a.rating) return b.rating - a.rating;
          return cmpDate(a, b);
        });
      } else if (mode === 'lowest-rating') {
        arr.sort(function (a, b) {
          if (a.rating !== b.rating) return a.rating - b.rating;
          return cmpDate(a, b);
        });
      } else if (mode === 'most-helpful') {
        arr.sort(function (a, b) {
          if (b.helpful !== a.helpful) return b.helpful - a.helpful;
          return cmpDate(a, b);
        });
      } else {
        // most-recent / only-pictures (already filtered)
        arr.sort(cmpDate);
      }
      return arr;
    }

    function filterByRating(list, rating) {
      if (!rating) return list;
      return list.filter(function (r) {
        return Math.round(r.rating) === rating;
      });
    }

    function renderCard(review) {
      var about = '';
      if (review.productTitle) {
        about =
          '<span class="dcoded-reviews__about">about ' +
          (review.productHref
            ? '<a href="' + escapeHtml(review.productHref) + '">' + escapeHtml(review.productTitle) + '</a>'
            : escapeHtml(review.productTitle)) +
          '</span>';
      }

      var verifiedBadge = review.verified
        ? '<span class="dcoded-reviews__verified">Verified</span>'
        : '';

      var pinHtml = review.pinned ? PIN_ICON_HTML : '';

      var photos = '';
      if (review.images && review.images.length) {
        photos =
          '<div class="dcoded-reviews__photos" data-dcoded-gallery>' +
          review.images
            .map(function (img, index) {
              var full = img.href || img.src;
              return (
                '<button type="button" class="dcoded-reviews__photo-btn" data-dcoded-lightbox-open data-index="' +
                index +
                '" data-full="' +
                escapeHtml(full) +
                '" data-thumb="' +
                escapeHtml(img.src) +
                '" aria-label="View photo ' +
                (index + 1) +
                ' of ' +
                review.images.length +
                '">' +
                '<img class="dcoded-reviews__photo" src="' +
                escapeHtml(img.src) +
                '" alt="" loading="lazy" />' +
                '</button>'
              );
            })
            .join('') +
          '</div>';
      }

      var title = review.title
        ? '<p class="dcoded-reviews__card-title">' + escapeHtml(review.title) + '</p>'
        : '';

      return (
        '<article class="dcoded-reviews__card' +
        (review.pinned ? ' dcoded-reviews__card--pinned' : '') +
        '" data-review-id="' +
        escapeHtml(review.id) +
        '">' +
        '<div class="dcoded-reviews__card-header">' +
        '<span class="dcoded-reviews__card-stars" role="img" aria-label="' +
        review.rating +
        ' out of 5">' +
        starsHtml(review.rating) +
        '</span>' +
        '<span class="dcoded-reviews__date">' +
        escapeHtml(formatDate(review.dateRaw)) +
        '</span>' +
        '</div>' +
        '<div class="dcoded-reviews__card-meta">' +
        '<div class="dcoded-reviews__card-meta-left">' +
        avatarHtml(review.verified) +
        '<span class="dcoded-reviews__author">' +
        escapeHtml(review.author) +
        '</span>' +
        verifiedBadge +
        about +
        '</div>' +
        pinHtml +
        '</div>' +
        title +
        '<p class="dcoded-reviews__body">' +
        escapeHtml(review.body) +
        '</p>' +
        photos +
        '</article>'
      );
    }

    function DcodedReviews(section) {
      this.section = section;
      this.listEl = qs(section, '[data-dcoded-list]');
      this.moreWrap = qs(section, '[data-dcoded-more]');
      this.moreBtn = qs(section, '[data-dcoded-more-btn]');
      this.emptyEl = qs(section, '[data-dcoded-empty]');
      this.sortEl = qs(section, '[data-dcoded-sort]');
      this.writeBtn = qs(section, '[data-dcoded-write-review]');
      this.jmWrite = qs(section, '[data-dcoded-jm-write], .jdgm-write-rev-link');
      this.writePanel = qs(section, '[data-dcoded-write-panel]');
      this.writeForm = qs(section, '[data-dcoded-write-form]');
      this.writeSuccess = qs(section, '[data-dcoded-write-success]');
      this.writeStatus = qs(section, '[data-dcoded-form-status]');
      this.ratingPicker = qs(section, '[data-dcoded-rating-picker]');
      this.ratingInput = qs(section, '[data-dcoded-rating-input]');
      this.photoInput = qs(section, '[data-dcoded-photos]');
      this.photoPreviews = qs(section, '[data-dcoded-photo-previews]');
      this.histRoot = qs(section, '[data-dcoded-histogram]');
      this.summaryText = qs(section, '[data-dcoded-summary-text]');
      this.summaryAverage = qs(section, '[data-dcoded-summary-average]');
      this.summaryStars = qs(section, '[data-dcoded-summary-stars]');

      this.shopDomain = section.getAttribute('data-shop-domain') || '';
      this.apiToken = section.getAttribute('data-api-token') || '';
      this.productId = section.getAttribute('data-product-id') || '';
      this.productTitle = section.getAttribute('data-product-title') || '';
      this.productUrl = section.getAttribute('data-product-url') || '';
      this.pageSize = parseInt(section.getAttribute('data-page-size') || '6', 10) || 6;
      this.sort = section.getAttribute('data-default-sort') || 'pictures-first';
      this.ratingFilter = null;
      this.visibleCount = this.pageSize;
      this.reviews = [];
      this.seedReviews = [];
      this.frequencies = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      this.totalCount = parseInt(section.getAttribute('data-all-count') || '0', 10) || 0;
      this.avgRating = parseFloat(section.getAttribute('data-all-rating') || '5') || 5;
      this.fetching = false;
      this.selectedFiles = [];
      this.previewUrls = [];
      this.submitting = false;
      this.lightboxImages = [];
      this.lightboxIndex = 0;
      this.ensureLightbox();

      if (this.sortEl) {
        this.sortEl.value = this.sort;
        var opt = this.sortEl.querySelector('option[value="' + this.sort + '"]');
        if (opt) opt.selected = true;
      }

      this.bind();
      this.boot();
    }

    DcodedReviews.prototype.bind = function () {
      var self = this;

      if (this.sortEl) {
        this.sortEl.addEventListener('change', function () {
          self.sort = self.sortEl.value || 'pictures-first';
          self.visibleCount = self.pageSize;
          self.paintList();
        });
      }

      if (this.histRoot) {
        this.histRoot.addEventListener('click', function (e) {
          var row = e.target.closest('[data-rating]');
          if (!row || !self.histRoot.contains(row)) return;
          var rating = parseInt(row.getAttribute('data-rating') || '0', 10);
          if (!rating) return;
          if (self.ratingFilter === rating) {
            self.ratingFilter = null;
          } else {
            self.ratingFilter = rating;
          }
          self.visibleCount = self.pageSize;
          self.paintHistogram();
          self.paintList();
        });
      }

      if (this.moreBtn) {
        this.moreBtn.addEventListener('click', function () {
          self.visibleCount += self.pageSize;
          self.paintList(true);
        });
      }

      if (this.writeBtn) {
        this.writeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          self.openWriteForm();
        });
      }

      qsa(this.section, '[data-dcoded-write-close]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.closeWriteForm();
        });
      });

      if (this.ratingPicker) {
        this.ratingPicker.addEventListener('click', function (e) {
          var star = e.target.closest('[data-rating-value]');
          if (!star) return;
          var value = parseInt(star.getAttribute('data-rating-value') || '0', 10);
          self.setRating(value);
          self.clearFieldError('rating');
        });
        this.ratingPicker.addEventListener('mouseover', function (e) {
          var star = e.target.closest('[data-rating-value]');
          if (!star) return;
          self.paintRatingStars(parseInt(star.getAttribute('data-rating-value') || '0', 10));
        });
        this.ratingPicker.addEventListener('mouseleave', function () {
          var current = parseInt((self.ratingInput && self.ratingInput.value) || '0', 10) || 0;
          self.paintRatingStars(current);
        });
      }

      if (this.photoInput) {
        this.photoInput.addEventListener('change', function () {
          self.onPhotosSelected(self.photoInput.files);
        });
      }

      if (this.writeForm) {
        this.writeForm.addEventListener('submit', function (e) {
          e.preventDefault();
          self.submitWriteForm();
        });
        qsa(this.writeForm, 'input, textarea').forEach(function (el) {
          el.addEventListener('input', function () {
            self.clearFieldError(el.name);
          });
        });
      }

      this.section.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-dcoded-lightbox-open]');
        if (!openBtn || !self.section.contains(openBtn)) return;
        e.preventDefault();
        var gallery = openBtn.closest('[data-dcoded-gallery]');
        var buttons = gallery ? qsa(gallery, '[data-dcoded-lightbox-open]') : [openBtn];
        var images = buttons
          .map(function (btn) {
            return {
              full: btn.getAttribute('data-full') || btn.getAttribute('data-thumb') || '',
              thumb: btn.getAttribute('data-thumb') || btn.getAttribute('data-full') || ''
            };
          })
          .filter(function (img) {
            return !!img.full;
          });
        var start = parseInt(openBtn.getAttribute('data-index') || '0', 10) || 0;
        self.openLightbox(images, start);
      });

      this.watchJudgeMeSubmit();
    };

    DcodedReviews.prototype.ensureLightbox = function () {
      if (document.getElementById('dcoded-reviews-lightbox')) {
        this.lightbox = document.getElementById('dcoded-reviews-lightbox');
        this.bindLightboxControls();
        return;
      }

      var el = document.createElement('div');
      el.id = 'dcoded-reviews-lightbox';
      el.className = 'dcoded-reviews-lightbox';
      el.hidden = true;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Review photo');
      el.innerHTML =
        '<div class="dcoded-reviews-lightbox__backdrop" data-lightbox-close></div>' +
        '<div class="dcoded-reviews-lightbox__dialog">' +
        '<button type="button" class="dcoded-reviews-lightbox__close" data-lightbox-close aria-label="Close">&times;</button>' +
        '<button type="button" class="dcoded-reviews-lightbox__nav dcoded-reviews-lightbox__nav--prev" data-lightbox-prev aria-label="Previous photo">&#10094;</button>' +
        '<div class="dcoded-reviews-lightbox__stage">' +
        '<img class="dcoded-reviews-lightbox__img" data-lightbox-img alt="" />' +
        '</div>' +
        '<button type="button" class="dcoded-reviews-lightbox__nav dcoded-reviews-lightbox__nav--next" data-lightbox-next aria-label="Next photo">&#10095;</button>' +
        '<div class="dcoded-reviews-lightbox__thumbs" data-lightbox-thumbs></div>' +
        '<p class="dcoded-reviews-lightbox__counter" data-lightbox-counter></p>' +
        '</div>';
      document.body.appendChild(el);
      this.lightbox = el;
      this.bindLightboxControls();
    };

    DcodedReviews.prototype.bindLightboxControls = function () {
      var self = this;
      if (!this.lightbox || this.lightbox.__dcodedBound) return;
      this.lightbox.__dcodedBound = true;

      this.lightbox.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]')) {
          self.closeLightbox();
          return;
        }
        if (e.target.closest('[data-lightbox-prev]')) {
          self.stepLightbox(-1);
          return;
        }
        if (e.target.closest('[data-lightbox-next]')) {
          self.stepLightbox(1);
          return;
        }
        var thumb = e.target.closest('[data-lightbox-thumb]');
        if (thumb) {
          var idx = parseInt(thumb.getAttribute('data-lightbox-thumb') || '0', 10) || 0;
          self.showLightboxIndex(idx);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (!self.lightbox || self.lightbox.hidden) return;
        if (e.key === 'Escape') self.closeLightbox();
        if (e.key === 'ArrowLeft') self.stepLightbox(-1);
        if (e.key === 'ArrowRight') self.stepLightbox(1);
      });
    };

    DcodedReviews.prototype.openLightbox = function (images, startIndex) {
      this.ensureLightbox();
      if (!images || !images.length) return;
      this.lightboxImages = images;
      this.lightboxIndex = Math.max(0, Math.min(startIndex || 0, images.length - 1));
      this.lightbox.hidden = false;
      document.documentElement.classList.add('dcoded-lightbox-open');
      this.renderLightbox();
    };

    DcodedReviews.prototype.closeLightbox = function () {
      if (!this.lightbox) return;
      this.lightbox.hidden = true;
      document.documentElement.classList.remove('dcoded-lightbox-open');
      this.lightboxImages = [];
      this.lightboxIndex = 0;
    };

    DcodedReviews.prototype.stepLightbox = function (delta) {
      if (!this.lightboxImages.length) return;
      var next = (this.lightboxIndex + delta + this.lightboxImages.length) % this.lightboxImages.length;
      this.showLightboxIndex(next);
    };

    DcodedReviews.prototype.showLightboxIndex = function (index) {
      if (!this.lightboxImages.length) return;
      this.lightboxIndex = Math.max(0, Math.min(index, this.lightboxImages.length - 1));
      this.renderLightbox();
    };

    DcodedReviews.prototype.renderLightbox = function () {
      if (!this.lightbox) return;
      var images = this.lightboxImages;
      var index = this.lightboxIndex;
      var current = images[index];
      if (!current) return;

      var img = qs(this.lightbox, '[data-lightbox-img]');
      if (img) {
        img.src = current.full;
        img.alt = 'Review photo ' + (index + 1) + ' of ' + images.length;
      }

      var counter = qs(this.lightbox, '[data-lightbox-counter]');
      if (counter) {
        counter.textContent = images.length > 1 ? index + 1 + ' / ' + images.length : '';
        counter.hidden = images.length < 2;
      }

      var prev = qs(this.lightbox, '[data-lightbox-prev]');
      var next = qs(this.lightbox, '[data-lightbox-next]');
      var showNav = images.length > 1;
      if (prev) prev.hidden = !showNav;
      if (next) next.hidden = !showNav;

      var thumbs = qs(this.lightbox, '[data-lightbox-thumbs]');
      if (thumbs) {
        if (images.length < 2) {
          thumbs.hidden = true;
          thumbs.innerHTML = '';
        } else {
          thumbs.hidden = false;
          thumbs.innerHTML = images
            .map(function (item, i) {
              return (
                '<button type="button" class="dcoded-reviews-lightbox__thumb' +
                (i === index ? ' is-active' : '') +
                '" data-lightbox-thumb="' +
                i +
                '" aria-label="Show photo ' +
                (i + 1) +
                '" aria-current="' +
                (i === index ? 'true' : 'false') +
                '">' +
                '<img src="' +
                escapeHtml(item.thumb || item.full) +
                '" alt="" />' +
                '</button>'
              );
            })
            .join('');
        }
      }
    };

    DcodedReviews.prototype.setRating = function (value) {
      if (this.ratingInput) this.ratingInput.value = String(value);
      this.paintRatingStars(value);
      qsa(this.ratingPicker, '[data-rating-value]').forEach(function (star) {
        var v = parseInt(star.getAttribute('data-rating-value') || '0', 10);
        star.setAttribute('aria-checked', v === value ? 'true' : 'false');
      });
    };

    DcodedReviews.prototype.paintRatingStars = function (value) {
      qsa(this.ratingPicker, '[data-rating-value]').forEach(function (star) {
        var v = parseInt(star.getAttribute('data-rating-value') || '0', 10);
        star.classList.toggle('is-on', v <= value);
      });
    };

    DcodedReviews.prototype.clearFieldError = function (name) {
      var err = qs(this.writeForm, '[data-error-for="' + name + '"]');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
      var field = this.writeForm && this.writeForm.elements[name];
      if (field && field.classList) field.classList.remove('is-invalid');
    };

    DcodedReviews.prototype.setFieldError = function (name, message) {
      var err = qs(this.writeForm, '[data-error-for="' + name + '"]');
      if (err) {
        err.hidden = false;
        err.textContent = message;
      }
      var field = this.writeForm && this.writeForm.elements[name];
      if (field && field.classList) field.classList.add('is-invalid');
    };

    DcodedReviews.prototype.setFormStatus = function (message, isError) {
      if (!this.writeStatus) return;
      if (!message) {
        this.writeStatus.hidden = true;
        this.writeStatus.textContent = '';
        this.writeStatus.classList.remove('is-error');
        return;
      }
      this.writeStatus.hidden = false;
      this.writeStatus.textContent = message;
      this.writeStatus.classList.toggle('is-error', !!isError);
    };

    DcodedReviews.prototype.openWriteForm = function () {
      if (!this.writePanel) return;
      if (this.writeForm) this.writeForm.hidden = false;
      if (this.writeSuccess) this.writeSuccess.hidden = true;
      this.setFormStatus('');
      this.writePanel.hidden = false;
      try {
        this.writePanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (e) {}
      var nameField = this.writeForm && this.writeForm.elements.name;
      if (nameField) nameField.focus();
    };

    DcodedReviews.prototype.closeWriteForm = function () {
      if (this.writePanel) this.writePanel.hidden = true;
      this.setFormStatus('');
    };

    DcodedReviews.prototype.resetWriteForm = function () {
      if (this.writeForm) this.writeForm.reset();
      this.setRating(0);
      this.clearPhotoPreviews();
      this.selectedFiles = [];
      if (this.photoInput) this.photoInput.value = '';
      qsa(this.writeForm, '[data-error-for]').forEach(function (el) {
        el.hidden = true;
        el.textContent = '';
      });
      qsa(this.writeForm, '.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });
      this.setFormStatus('');
    };

    DcodedReviews.prototype.clearPhotoPreviews = function () {
      (this.previewUrls || []).forEach(function (url) {
        try {
          URL.revokeObjectURL(url);
        } catch (e) {}
      });
      this.previewUrls = [];
      if (this.photoPreviews) this.photoPreviews.innerHTML = '';
    };

    DcodedReviews.prototype.onPhotosSelected = function (fileList) {
      var self = this;
      this.clearFieldError('pictures');
      this.clearPhotoPreviews();
      var files = Array.prototype.slice.call(fileList || []);
      var maxFiles = 5;
      var maxBytes = 5 * 1024 * 1024;
      var allowed = /image\/(jpeg|jpg|png|webp)/i;
      var valid = [];
      var error = '';

      files.forEach(function (file) {
        if (valid.length >= maxFiles) {
          error = 'You can upload up to 5 images.';
          return;
        }
        if (!allowed.test(file.type)) {
          error = 'Only JPG, PNG, or WEBP images are allowed.';
          return;
        }
        if (file.size > maxBytes) {
          error = 'Each image must be 5 MB or smaller.';
          return;
        }
        valid.push(file);
      });

      this.selectedFiles = valid;
      if (error) this.setFieldError('pictures', error);

      if (!this.photoPreviews) return;
      valid.forEach(function (file) {
        var url = URL.createObjectURL(file);
        self.previewUrls.push(url);
        var img = document.createElement('img');
        img.className = 'dcoded-reviews__photo-preview';
        img.src = url;
        img.alt = '';
        self.photoPreviews.appendChild(img);
      });
    };

    DcodedReviews.prototype.validateWriteForm = function () {
      var ok = true;
      var name = ((this.writeForm.elements.name && this.writeForm.elements.name.value) || '').trim();
      var email = ((this.writeForm.elements.email && this.writeForm.elements.email.value) || '').trim();
      var title = ((this.writeForm.elements.title && this.writeForm.elements.title.value) || '').trim();
      var body = ((this.writeForm.elements.body && this.writeForm.elements.body.value) || '').trim();
      var rating = parseInt((this.ratingInput && this.ratingInput.value) || '0', 10) || 0;

      qsa(this.writeForm, '[data-error-for]').forEach(function (el) {
        el.hidden = true;
        el.textContent = '';
      });
      qsa(this.writeForm, '.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });

      if (!rating || rating < 1 || rating > 5) {
        this.setFieldError('rating', 'Please select a star rating.');
        ok = false;
      }
      if (!name || name.length < 2) {
        this.setFieldError('name', 'Please enter your name.');
        ok = false;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.setFieldError('email', 'Please enter a valid email address.');
        ok = false;
      }
      if (!title || title.length < 2) {
        this.setFieldError('title', 'Please add a short review title.');
        ok = false;
      }
      if (!body || body.length < 10) {
        this.setFieldError('body', 'Please write at least 10 characters.');
        ok = false;
      }

      return ok
        ? { name: name, email: email, title: title, body: body, rating: rating }
        : null;
    };

    function judgeMeShopParams(shopDomain) {
      return {
        url: shopDomain,
        shop_domain: shopDomain,
        platform: 'shopify'
      };
    }

    function parseJudgeMeError(res, text) {
      var detail = text || '';
      try {
        var j = JSON.parse(text);
        detail = j.error || j.message || (j.errors && JSON.stringify(j.errors)) || text;
      } catch (e) {}
      return detail || 'Judge.me rejected the review (' + res.status + ')';
    }

    function normalizeUploadFileName(name) {
      var cleaned = String(name || 'photo.jpg').replace(/[^a-z0-9-_.]/gi, '');
      var parts = cleaned.split('.');
      var ext = parts.pop() || 'jpg';
      var base = parts.join('');
      if (!base) base = String(Date.now());
      return encodeURIComponent(base + '.' + ext);
    }

    function fileForJudgeMeUpload(file) {
      if (!file || !/^image\/webp/i.test(file.type)) {
        return Promise.resolve(file);
      }

      return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          try {
            var canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            canvas.getContext('2d').drawImage(img, 0, 0);
            canvas.toBlob(
              function (blob) {
                URL.revokeObjectURL(url);
                if (!blob) {
                  reject(new Error('Could not prepare your photo for upload.'));
                  return;
                }
                resolve(new File([blob], file.name.replace(/\.webp$/i, '.jpg'), { type: 'image/jpeg' }));
              },
              'image/jpeg',
              0.92
            );
          } catch (e) {
            URL.revokeObjectURL(url);
            reject(new Error('Could not prepare your photo for upload.'));
          }
        };
        img.onerror = function () {
          URL.revokeObjectURL(url);
          reject(new Error('Could not read one of your photos.'));
        };
        img.src = url;
      });
    }

    function fetchJudgeMePresignedData(shopDomain) {
      var params = new URLSearchParams(judgeMeShopParams(shopDomain));
      return fetch(PRESIGNED_PICTURES_API + '?' + params.toString(), {
        credentials: 'omit',
        mode: 'cors'
      }).then(function (res) {
        if (!res.ok) {
          return res.text().then(function (text) {
            throw new Error(parseJudgeMeError(res, text));
          });
        }
        return res.json();
      });
    }

    function uploadJudgeMePicture(file, presigned) {
      var formData = new FormData();
      var fileName = normalizeUploadFileName(file.name);
      formData.append('key', String(presigned.key_prefix || '') + fileName);
      Object.keys(presigned.fields || {}).forEach(function (key) {
        formData.append(key, presigned.fields[key]);
      });
      formData.append('file', file);

      return fetch(presigned.url, {
        method: 'POST',
        body: formData,
        credentials: 'omit',
        mode: 'cors'
      }).then(function (res) {
        return res.text().then(function (text) {
          if (!res.ok) {
            throw new Error('Photo upload failed. Please try again with JPG or PNG images.');
          }
          var doc = new DOMParser().parseFromString(text, 'text/xml');
          var keyEl = doc.querySelector('Key');
          if (!keyEl || !keyEl.textContent) {
            throw new Error('Photo upload failed. Please try again.');
          }
          return keyEl.textContent;
        });
      });
    }

    function uploadJudgeMePictures(files, shopDomain) {
      var list = (files || []).slice(0, 5);
      if (!list.length) return Promise.resolve([]);

      return fetchJudgeMePresignedData(shopDomain).then(function (presigned) {
        var keys = [];
        var chain = Promise.resolve();

        list.forEach(function (file) {
          chain = chain.then(function () {
            return fileForJudgeMeUpload(file).then(function (uploadFile) {
              return uploadJudgeMePicture(uploadFile, presigned).then(function (key) {
                keys.push(key);
              });
            });
          });
        });

        return chain.then(function () {
          return keys;
        });
      });
    }

    function buildJudgeMeReviewFormData(data, shopDomain, productId, pictureKeys) {
      var formData = new FormData();
      var fields = Object.assign({}, judgeMeShopParams(shopDomain), {
        reviewer_name_format: '',
        name: data.name,
        email: data.email,
        rating: String(data.rating),
        title: data.title,
        body: data.body,
        id: String(productId)
      });

      Object.keys(fields).forEach(function (key) {
        var value = fields[key];
        if (value != null && value !== '') {
          formData.append(key, value);
        }
      });

      (pictureKeys || []).forEach(function (key, index) {
        formData.append('picture_keys[' + index + ']', key);
      });

      return formData;
    }

    function submitJudgeMeReview(formData) {
      return fetch(REVIEW_API, {
        method: 'POST',
        body: formData,
        credentials: 'omit',
        mode: 'cors'
      }).then(function (res) {
        if (res.ok) {
          return res.json().catch(function () {
            return {};
          });
        }
        return res.text().then(function (text) {
          throw new Error(parseJudgeMeError(res, text));
        });
      });
    }

    DcodedReviews.prototype.submitWriteForm = function () {
      var self = this;
      if (this.submitting) return;
      var data = this.validateWriteForm();
      if (!data) {
        this.setFormStatus('Please fix the highlighted fields.', true);
        return;
      }
      if (!this.shopDomain || !this.productId) {
        this.setFormStatus('Unable to submit review for this product. Please refresh and try again.', true);
        return;
      }

      this.submitting = true;
      var submitBtn = qs(this.writeForm, '[data-dcoded-write-submit]');
      if (submitBtn) submitBtn.disabled = true;
      this.setFormStatus('Submitting your review…');

      var files = (self.selectedFiles || []).slice(0, 5);

      if (files.length) {
        self.setFormStatus('Uploading photos…');
      }

      uploadJudgeMePictures(files, self.shopDomain)
        .then(function (pictureKeys) {
          if (files.length && !pictureKeys.length) {
            throw new Error('Your photos could not be uploaded. Please try again.');
          }
          if (pictureKeys.length) {
            self.setFormStatus('Submitting your review…');
          }
          return submitJudgeMeReview(
            buildJudgeMeReviewFormData(data, self.shopDomain, self.productId, pictureKeys)
          );
        })
        .then(function () {
          if (self.writeForm) self.writeForm.hidden = true;
          if (self.writeSuccess) self.writeSuccess.hidden = false;
          self.resetWriteForm();
          if (self.writeForm) self.writeForm.hidden = true;
          setTimeout(function () {
            self.refreshFromApi();
          }, 2500);
        })
        .catch(function (err) {
          var msg =
            (err && err.message) ||
            'Could not submit your review. Please try again in a moment.';
          if (/Failed to fetch|NetworkError|CORS/i.test(msg)) {
            msg =
              'Could not reach Judge.me from the browser. Please try again, or disable any ad blockers for this site.';
          }
          self.setFormStatus(msg, true);
        })
        .then(function () {
          self.submitting = false;
          if (submitBtn) submitBtn.disabled = false;
        });
    };

    DcodedReviews.prototype.openWriteModal = function () {
      this.openWriteForm();
    };

    DcodedReviews.prototype.watchJudgeMeSubmit = function () {
      var self = this;
      var refreshSoon = function () {
        clearTimeout(self._refreshTimer);
        self._refreshTimer = setTimeout(function () {
          self.refreshFromApi();
        }, 1200);
      };

      document.addEventListener(
        'submit',
        function (e) {
          var form = e.target;
          if (!form || !form.closest) return;
          if (
            form.closest('.jdgm-form') ||
            form.closest('.jdgm-write-rev-form') ||
            form.closest('#judgeme_product_reviews') ||
            (form.className && String(form.className).indexOf('jdgm') !== -1)
          ) {
            refreshSoon();
          }
        },
        true
      );

      [
        'jdgm:reviewSubmitted',
        'jdgm.reviewSubmitted',
        'jdgm:formSubmitted',
        'judgeme:review:created'
      ].forEach(function (name) {
        document.addEventListener(name, refreshSoon);
        window.addEventListener(name, refreshSoon);
      });

      // Judge.me often closes modal / shows thank-you without a custom event
      var obs = new MutationObserver(function () {
        if (
          document.querySelector('.jdgm-form__success, .jdgm-notify--success, .jdgm-write-rev-popup--done')
        ) {
          refreshSoon();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    };

    DcodedReviews.prototype.boot = function () {
      var seed = parseSeed(this.section);
      this.seedReviews = seed.reviews || [];
      this.reviews = this.seedReviews.slice();
      if (seed.frequencies) {
        this.frequencies = seed.frequencies;
      } else {
        this.frequencies = frequenciesFromReviews(this.reviews);
      }
      if (!this.totalCount && this.reviews.length) {
        this.totalCount = this.reviews.length;
      }
      this.paintSummary();
      this.paintHistogram();
      this.paintList();
      this.refreshFromApi();
    };

    DcodedReviews.prototype.paintSummary = function () {
      var count = this.totalCount || this.reviews.length;
      var rating = Number(this.avgRating) || 5;
      if (this.summaryText) {
        this.summaryText.textContent =
          count === 1 ? 'Based on 1 review' : 'Based on ' + count + ' reviews';
      }
      if (this.summaryAverage) {
        this.summaryAverage.textContent = rating.toFixed(2) + ' out of 5';
      }
      if (this.summaryStars) {
        var filled = Math.max(0, Math.min(5, Math.round(rating)));
        this.summaryStars.innerHTML = starsHtml(filled || 5);
        this.summaryStars.setAttribute(
          'aria-label',
          'Average rating ' + rating.toFixed(2) + ' out of 5'
        );
      }
    };

    DcodedReviews.prototype.paintHistogram = function () {
      var self = this;
      var total = 0;
      for (var i = 1; i <= 5; i++) total += this.frequencies[i] || 0;
      if (!total) total = this.reviews.length || 1;

      qsa(this.histRoot, '[data-rating]').forEach(function (row) {
        var rating = parseInt(row.getAttribute('data-rating') || '0', 10);
        var freq = self.frequencies[rating] || 0;
        var pct = Math.round((freq / total) * 100);
        row.setAttribute('data-frequency', String(freq));
        row.setAttribute('data-percentage', String(pct));
        row.setAttribute('aria-pressed', self.ratingFilter === rating ? 'true' : 'false');
        var fill = qs(row, '.dcoded-reviews__hist-bar-fill');
        if (fill) fill.style.width = pct + '%';
        var countEl = qs(row, '[data-hist-count]');
        if (countEl) countEl.textContent = String(freq);
      });
    };

    DcodedReviews.prototype.getVisibleReviews = function () {
      var list = filterByRating(this.reviews, this.ratingFilter);
      return sortReviews(list, this.sort);
    };

    DcodedReviews.prototype.paintList = function (appendOnly) {
      var visible = this.getVisibleReviews();
      var slice = visible.slice(0, this.visibleCount);

      if (this.emptyEl) {
        this.emptyEl.hidden = slice.length > 0;
      }

      if (!this.listEl) return;

      if (appendOnly && this.listEl.children.length) {
        var already = this.listEl.children.length;
        var html = '';
        for (var i = already; i < slice.length; i++) {
          html += renderCard(slice[i]);
        }
        if (html) this.listEl.insertAdjacentHTML('beforeend', html);
      } else {
        this.listEl.innerHTML = slice.map(renderCard).join('');
      }

      if (this.moreWrap) {
        this.moreWrap.hidden = slice.length >= visible.length;
      }
    };

    DcodedReviews.prototype.applyApiMeta = function (json) {
      if (!json) return;
      if (typeof json.total_count === 'number') this.totalCount = json.total_count;
      else if (typeof json.number_of_reviews === 'number') this.totalCount = json.number_of_reviews;
      else if (json.widget && typeof json.widget.number_of_reviews === 'number') {
        this.totalCount = json.widget.number_of_reviews;
      }

      if (typeof json.average_rating === 'number') this.avgRating = json.average_rating;
      else if (json.widget && typeof json.widget.average_rating === 'number') {
        this.avgRating = json.widget.average_rating;
      }

      var hist =
        json.histogram ||
        (json.widget && json.widget.histogram) ||
        json.rating_distribution ||
        null;
      if (hist && typeof hist === 'object') {
        var f = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        [1, 2, 3, 4, 5].forEach(function (n) {
          var v = hist[n] != null ? hist[n] : hist[String(n)];
          if (v && typeof v === 'object') v = v.count != null ? v.count : v.frequency;
          if (typeof v === 'number') f[n] = v;
        });
        this.frequencies = f;
      }
    };

    DcodedReviews.prototype.fetchPage = function (page) {
      var url =
        API_BASE +
        '?shop_domain=' +
        encodeURIComponent(this.shopDomain) +
        '&api_token=' +
        encodeURIComponent(this.apiToken) +
        '&page=' +
        page +
        '&per_page=' +
        PER_PAGE;

      return fetch(url, { credentials: 'omit' }).then(function (res) {
        if (!res.ok) throw new Error('Judge.me API ' + res.status);
        return res.json();
      });
    };

    DcodedReviews.prototype.refreshFromApi = function () {
      var self = this;
      if (!this.shopDomain || !this.apiToken) return Promise.resolve();
      if (this.fetching) return Promise.resolve();
      this.fetching = true;

      var all = [];
      var seenIds = {};
      var page = 1;

      function next() {
        return self.fetchPage(page).then(function (json) {
          if (page === 1) self.applyApiMeta(json);

          if (page === 1 && json && json.all_reviews_header) {
            var headerFreq = parseFrequenciesFromHeaderHtml(json.all_reviews_header);
            if (headerFreq) self.frequencies = headerFreq;
          }

          var html =
            (json && json.all_reviews) ||
            (json && json.html) ||
            (json && json.widget && json.widget.html) ||
            (json && json.reviews_html) ||
            '';
          var batch = parseReviewsFromHtml(html);
          var added = 0;
          batch.forEach(function (r) {
            if (seenIds[r.id]) return;
            seenIds[r.id] = true;
            all.push(r);
            added += 1;
          });

          if (page >= MAX_PAGES || batch.length === 0) {
            return all;
          }

          var expected = self.totalCount || 0;
          if (expected && all.length >= expected) {
            return all;
          }

          page += 1;
          return next();
        });
      }

      return next()
        .then(function (reviews) {
          if (reviews && reviews.length) {
            self.reviews = mergeReviewLists(self.seedReviews, reviews);
            // Prefer counts from live published set if API histogram missing
            var computed = frequenciesFromReviews(self.reviews);
            var histSum = 0;
            for (var i = 1; i <= 5; i++) histSum += self.frequencies[i] || 0;
            if (!histSum) self.frequencies = computed;
          }
          if (!self.totalCount) self.totalCount = self.reviews.length;
          self.paintSummary();
          self.paintHistogram();
          self.paintList();
        })
        .catch(function () {
          /* keep seed UI */
        })
        .then(function () {
          self.fetching = false;
        });
    };

    function initAll() {
      qsa(document, '[data-dcoded-reviews]').forEach(function (section) {
        if (section.__dcodedReviews) return;
        section.__dcodedReviews = new DcodedReviews(section);
      });
    }

    if (!window.__dcodedScrollReviewsBound) {
      window.__dcodedScrollReviewsBound = true;
      document.addEventListener('click', function (e) {
        var link = e.target.closest('[data-dcoded-scroll-reviews]');
        if (!link) return;
        var target = document.getElementById('dcoded-customer-reviews');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        try {
          history.replaceState(null, '', '#dcoded-customer-reviews');
        } catch (err) {}
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target && e.target.querySelector && e.target.querySelector('[data-dcoded-reviews]')) {
        initAll();
      }
    });
  })();
